<template>
    <div>
        <div class="level">
            <div class="level-left">
                <h2 class="title is-size-5">{{ headline }}</h2>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <setting label="Valutakurs" :help-text="exchaneHelpText"
                         skey="inventory.exchange.rate"/>
            </div>
            <div class="column">
                <setting label="Pris timeout"
                         help-text="Hvor mange dage der skal være gået før priser markers som 'for gamle'."
                         skey="inventory.price.timeout"/>
            </div>
        </div>
    </div>
</template>

<script>
import Setting from '../Setting.vue'
import SettingFile from "../SettingFile";

export default {
    props: {
        headline: String,
        tab: String,
    },
    components: {
        Setting,
        SettingFile,
    },
    computed: {
        exchaneHelpText() {
            const link = '<a href=\"https://www.nationalbanken.dk/valutakurser" target="_blank">Nationalbanken</a>';
            return `Omregningsfaktor til omregning fra DKK til EUR (${link})`;
        }
    },
    created() {
        this.$store.dispatch('loadSettings')
    },
}
</script>

<style scoped>

</style>
